import React from "react";
import { useTranslate } from "hooks/translation-hooks";
import Modal from "./GenericModal";
import { mediaModalOpenSelector } from "redux/selectors/modals";
import { Body, Button, Buttons, Options, Row, Title } from "./ModalsStyled";
import { useMediaModal } from "./hooks";
import { useSelector } from "react-redux";
import CameraIcon from "components/Icons/CameraIcon/CameraIcon";
import GalleryIcon from "components/Icons/GalleryIcon/GalleryIcon";

const ContinueModal = ({ uploadPicturesInput }) => {
  const t = useTranslate();
  const open = useSelector(mediaModalOpenSelector);
  const { selectCamera, handleClose, selectMediaGallery } = useMediaModal({
    uploadPicturesInput
  });

  return (
    <Modal open={open} handleClose={handleClose}>
      <Title>{t("upload_photos_popup-title")}</Title>
      <Body>
        <Options>
          <Row onClick={selectCamera} data-testid="primary-button-modal">
            <CameraIcon />
            {t("upload_photos_popup-button_1")}
          </Row>
          <Row
            onClick={selectMediaGallery}
            data-testid="secondary-button-modal"
          >
            <GalleryIcon />
            {t("upload_photos_popup-button_2")}
          </Row>
        </Options>
      </Body>
      <Buttons>
        <Button onClick={handleClose} data-testid="close-modal-button">
          {t("upload_photos_popup_decline")}
        </Button>
      </Buttons>
    </Modal>
  );
};

export default ContinueModal;
